module.exports = __webpack_public_path__ + "img/ghibli.36316672.png";